export default __webpack_public_path__ + "static/Robowealth_logo-979880addc78962f5fa9b445c452ea6c.png";